import { useContext, useEffect, useReducer } from "react";
import { configStore } from "../../contexts/ConfigContext";
import { errorStore } from "../../contexts/ErrorContext";
import { LoaderStatus } from "../../interfaces/Status";
import { axiosClient } from "../../utils/axios-client/axios-client";

const useAxiosClientInit = (appStatus: LoaderStatus | undefined): boolean => {
  const { setConfig } = useContext(configStore);
  const { setErrorInfo } = useContext(errorStore);

  const [axiosClientInitialized, markAxiosClientInitialized] = useReducer(
    () => true,
    false,
  );
  useEffect(() => {
    (async () => {
      const apiUrls = await axiosClient.init();
      setConfig((config) => {
        return { ...config, apiUrls };
      });
      markAxiosClientInitialized();
    })();
  }, [setConfig]);

  const [
    tokenInvalidInterceptorInitialized,
    markTokenInvalidInterceptorInitialized,
  ] = useReducer(() => true, false);
  useEffect(() => {
    if (!axiosClientInitialized) return;

    // While the app is still loading, an invalidated token means we can't
    // start the session at all, so show a full error page.
    // Post-load the interceptor no longer needs to drive any UI itself (SessionGuard does the job)
    if (appStatus !== LoaderStatus.Success) {
      axiosClient.updateTokenInvalidatedInterceptor(() => {
        setErrorInfo({
          displayModal: false,
          page: {
            code: "token",
          },
        });
      });
    } else {
      axiosClient.updateTokenInvalidatedInterceptor(() => {});
    }
    markTokenInvalidInterceptorInitialized();
  }, [appStatus, setErrorInfo, axiosClientInitialized]);

  return axiosClientInitialized && tokenInvalidInterceptorInitialized;
};
export default useAxiosClientInit;
